import { Box } from "@mui/material";
import React from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  // @ts-ignore
  Marker,
} from "react-simple-maps";
import { colors } from "../../../theme/palette";
import { Country } from "../../../types";

const geoUrl =
  "https://raw.githubusercontent.com/holtzy/D3-graph-gallery/master/DATA/world.geojson";

type EntityMapProps = {
  countries: Country[];
};

const EntityMap: React.FC<EntityMapProps> = ({ countries }) => {
  const transformedCountries = countries
    ?.filter(
      (country) =>
        country.coordinates !== undefined && country.coordinates.length === 2
    )
    .map((country) => ({
      ...country,
      coordinates: country.coordinates!.map(Number) as [number, number],
    }));

  return (
    <Box
      style={{
        width: "100%",
        maxWidth: "400px",
        maxHeight: "300px",
        aspectRatio: "4 / 3", // Aspect ratio of 4:3
        marginTop: "-30px",
      }}
    >
      <ComposableMap>
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                // @ts-ignore
                style={{
                  default: {
                    fill: colors.gray200,
                    outline: "none",
                  },
                  hover: {
                    fill: colors.gray200,
                    outline: "none",
                  },
                  pressed: {
                    fill: colors.gray200,
                    outline: "none",
                  },
                }}
              />
            ))
          }
        </Geographies>
        {transformedCountries.map(({ country, coordinates }) => (
          <Marker key={country} coordinates={coordinates}>
            <circle
              cx={0}
              cy={0}
              r={14} // Outer circle radius
              fill="rgba(0, 128, 0, 0.3)" // Light green with opacity
            />
            <circle
              cx={0}
              cy={0}
              r={4} // Inner circle radius
              fill="#008000" // Strong green
            />
          </Marker>
        ))}
      </ComposableMap>
    </Box>
  );
};

export default EntityMap;
